import React from 'react'
import { Card, CardProps } from '@arco-design/web-react'
import styles from './index.module.less'

export default function EchoCard({ title, children, style, className = '', extra, ...props }: CardProps) {
  const combinedClassName = Array.isArray(className) ? [styles.container, ...className] : [styles.container, className]

  return (
    <Card
      className={combinedClassName}
      title={title ? <span className={styles.title}>{title}</span> : null}
      style={{ borderRadius: '16px', padding: '12px', ...style }}
      extra={extra ? extra : null}
      {...props}
    >
      {children}
    </Card>
  )
}
